module.exports = __webpack_public_path__ + "static/media/logo.c851c269.svg";